 
 const devPayload_ = {
    userLogedIn:           'true',
    userName:              'localhost',
    userEmail:             'localhost@gmail.com',
    userRole:              '',
    semelMosad:            '99999999,111096,512988',
    userId:                '',
    gradeAccess:           ['1','2','3','4','5','6','7'],
   userFoundInTables:     ['table1', 'table2'],
    plus:                  true,
    subscriptionExpired:   false,
   userExists:            1,
    subscriptionExpiresAt: '2023-09-01',
   session:               "name=test&mail=123&user=teacher&semel_mosad=123&ip=123.123.123.123",
   permissionResolved:    true
}
 

 const guestPayload = {
  userLogedIn:           'false',
  userName:              'guest',
  userEmail:             'guest@yisumatica.org.il',
  userRole:              '',
  semelMosad:            '',
  userId:                '',
  gradeAccess:           ['1','2','3','4','5','6','7'],
  userFoundInTables:     [],
  plus:                  false,
  subscriptionExpired:   false,
  userExists:            0,
  subscriptionExpiresAt: '',
  session:               "name=test&mail=&user=&semel_mosad=&ip=123.123.123.123",
  permissionResolved:    true
}
 
export const devPayload = [devPayload_, guestPayload][0];



const lsPermissions = localStorage.getItem( 'yisumaticaPermissions' );
let stored: { [key: string]: any; } = {};

if ( lsPermissions && lsPermissions === 'string' ) { 
  stored = JSON.parse(lsPermissions);
}
      
export const errPayload = {
  userLogedIn:           'false',
  userExists:            -1,
  userName:              '',
  userEmail:             '',
  semelMosad:            '',
  userId:                '',
  userRole:              'student',
  userFoundInTables:     [],
  plus:                  !!stored.plus ? stored.plus : false, 
  gradeAccess:           !!stored.gradeAccess ? stored.gradeAccess : [],
  subscriptionExpired:   !!stored.subscriptionExpired ? stored.subscriptionExpired : false, 
  subscriptionExpiresAt: stored.subscriptionExpiresAt ? stored.subscriptionExpiresAt : '',
  permissionResolved:    false,
  session:               ''
}